import { UserImage } from 'interfaces/userImage'
import { FC, useMemo } from 'react'
import AdjustableImage from 'components/features/pfm/AdjustableImage/AdjustableImage'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import SvgIcon from 'components/atoms/SvgIcon'
import ErrorImageSvg from 'icons/report.svg'
import styles from 'components/features/socialFeed/ComposeImage/ComposeImage.styl'
import cn from 'classnames'
import { Removable } from 'components/features/pfm/Removable/Removable'

type ComposeImageProps = {
  userImage: UserImage
  onRemove: () => void
}

export const ComposeImage: FC<ComposeImageProps> = ({
  userImage,
  onRemove,
}) => {
  const { image, localImage, errorCode, isLoading } = userImage
  const isError = errorCode !== null

  const className = useMemo(() => cn(
    styles.imageWrapper,
    {
      [styles.error]: isError,
      [styles.loading]: isLoading && !isError,
    }
  ), [isError, isLoading])

  return (
    <Removable onRemove={ onRemove }>
      <div className={ className }>
        <div className={ styles.imageCorners }>
          <AdjustableImage image={ image || localImage } />
        </div>

        { isLoading && !isError &&
          <div className={ styles.preloader }>
            <Spinner size='large' />
          </div>}
        { isError &&
          <div className={ styles.errorIcon }>
            <SvgIcon src={ ErrorImageSvg } />
          </div>}
      </div>
    </Removable>
  )
}
